import {
  adjustMeterApiCall,
  clearPlanFeatureApiCall,
  clearProviderFeatureOverrideApiCall,
  deleteAddOnApiCall,
  deleteFeatureApiCall,
  getAddOnsApiCall,
  getFeaturesApiCall,
  getMeterHistoryApiCall,
  getPlanFeaturesApiCall,
  getProviderAddOnsApiCall,
  getProviderEntitlementsApiCall,
  getProviderFeatureOverridesApiCall,
  getProviderMetersApiCall,
  grantProviderAddOnApiCall,
  removeAddOnGrantApiCall,
  revokeProviderAddOnApiCall,
  setAddOnActiveApiCall,
  setAddOnGrantApiCall,
  setPlanFeatureApiCall,
  setProviderFeatureOverrideApiCall,
  upsertAddOnApiCall,
  upsertFeatureApiCall,
} from '@guryou/api-client-gql';

// Thin admin wrappers around the generated entitlement clients, exposed through
// @guryou/redux (the app depends on this package, not on @guryou/api-client-gql
// directly). Each returns the api-call result shape { success, data }.

export const adminGetFeatures = () => getFeaturesApiCall();
export const adminUpsertFeature = request => upsertFeatureApiCall({ request });
export const adminDeleteFeature = key => deleteFeatureApiCall({ key });

// Read-only inspector: resolve a single provider's effective entitlements
// (plan ⊕ add-ons ⊕ override). Used to verify the resolver before wiring gates.
export const adminGetProviderEntitlements = providerId => getProviderEntitlementsApiCall({ providerId });

// Per-provider write surface (admin grant/revoke).
// Overrides force a feature on/off/limit for one provider; add-on grants assign a catalog
// add-on to a provider. value/grant are JSON the resolver parses (e.g. true, {limit:N}).
export const adminGetProviderFeatureOverrides = providerId => getProviderFeatureOverridesApiCall({ providerId });
export const adminSetProviderFeatureOverride = (providerId, featureKey, value, reason, expiresAt) =>
  setProviderFeatureOverrideApiCall({ providerId, featureKey, value, reason, expiresAt });
export const adminClearProviderFeatureOverride = (providerId, featureKey) => clearProviderFeatureOverrideApiCall({ providerId, featureKey });

export const adminGetProviderAddOns = providerId => getProviderAddOnsApiCall({ providerId });
export const adminGrantProviderAddOn = (providerId, addOnId, quantity, expiresAt) =>
  grantProviderAddOnApiCall({ providerId, addOnId, quantity, expiresAt });
export const adminRevokeProviderAddOn = id => revokeProviderAddOnApiCall({ id });

// Metered usage: a provider's credit balances + the append-only ledger behind them.
export const adminGetProviderMeters = providerId => getProviderMetersApiCall({ providerId });
export const adminGetMeterHistory = (providerId, featureKey) => getMeterHistoryApiCall({ providerId, featureKey });
export const adminAdjustMeter = (providerId, featureKey, delta, reason, eventType) =>
  adjustMeterApiCall({ providerId, featureKey, delta, reason, eventType });

export const adminGetPlanFeatures = () => getPlanFeaturesApiCall();
export const adminSetPlanFeature = (planId, featureKey, value) => setPlanFeatureApiCall({ planId, featureKey, value });
export const adminClearPlanFeature = (planId, featureKey) => clearPlanFeatureApiCall({ planId, featureKey });

export const adminGetAddOns = () => getAddOnsApiCall({ grants: ['featureKey', 'grantValue'] });
export const adminUpsertAddOn = request => upsertAddOnApiCall({ request });
export const adminSetAddOnActive = (id, active) => setAddOnActiveApiCall({ id, active });
export const adminDeleteAddOn = id => deleteAddOnApiCall({ id });
export const adminSetAddOnGrant = (addOnId, featureKey, grantValue) => setAddOnGrantApiCall({ addOnId, featureKey, grantValue });
export const adminRemoveAddOnGrant = (addOnId, featureKey) => removeAddOnGrantApiCall({ addOnId, featureKey });
